import { PlayIcon } from './components/Play';
import { SearchIcon } from './components/Search';
import { InfoIcon } from './components/Info';
import { InputIcon } from './components/Input';
import { MultiOptionsIcon } from './components/MultiOptions';
import { PencilIcon } from './components/Pencil';
import { CloseIcon } from './components/Close';
import { SubmitIcon } from './components/Submit';
import { PlusIcon } from './components/Plus';
import { DeleteIcon } from './components/Delete';
import { FinishIcon } from './components/Finish';
import { IfConditionIcon } from './components/IfCondition';
import { TimeoutIcon } from './components/Timeout';
import { NourishmentIcon } from './components/Nourishment';
import { RunIcon } from './components/Run';
import { MedicationIcon } from './components/Medication';
import { YogaIcon } from './components/Yoga';
import { DragHandlerIcon } from './components/DragHandler';
import { ArrowBottomIcon } from './components/ArrowBottom';
import { AiIcon } from './components/Ai';
import { AlternativesIcon } from './components/Alternatives';
import { CheckTickIcon } from '@src/components/icon/components/CheckTick';
import { ImagePlaceholderIcon } from './components/ImagePlaceholder';
import { ImageIcon } from './components/Image';


import cn from 'classnames';
import { cva } from 'class-variance-authority';

const iconVariants = cva(
  'flex justify-center items-center',
  {
    variants: {
      variant: {
        default: '',
        nodeIcon: 'bg-input text-primary-foreground rounded-md',
      },
      size: {
        small: 'w-4 h-4',
        medium: 'w-6 h-6',
        large: 'w-8 h-8',
      },
    },
    defaultVariants: {
      size: 'medium',
      variant: 'default',
    },
  }
)

const iconTypes = {
  play: PlayIcon,
  search: SearchIcon,
  info: InfoIcon,
  input: InputIcon,
  pencil: PencilIcon,
  close: CloseIcon,
  submit: SubmitIcon,
  plus: PlusIcon,
  delete: DeleteIcon,
  finish: FinishIcon,
  timeout: TimeoutIcon,
  nourishment: NourishmentIcon,
  run: RunIcon,
  medication: MedicationIcon,
  yoga: YogaIcon,
  ai: AiIcon,
  alternatives: AlternativesIcon,
  check: CheckTickIcon,
  image: ImageIcon,
  'drag-handler': DragHandlerIcon,
  'multi-options': MultiOptionsIcon,
  'if-condition': IfConditionIcon,
  'arrow-bottom': ArrowBottomIcon,
  'image-placeholder': ImagePlaceholderIcon,
}

export type IconType = keyof typeof iconTypes;

interface IconProps {
  type: keyof typeof iconTypes;
  variant?: 'default' | 'nodeIcon';
  size?: 'small' | 'medium' | 'large';
  className?: string;
  svgProps?: React.SVGProps<SVGSVGElement>;
  style?: React.CSSProperties;
  color?: string;
}
export const Icon = ({ type, className, variant, size, svgProps, color }: IconProps) => {
  const IconComponent = iconTypes[type];

  if (!IconComponent) {
    return null;
  }

  return (
    <div className={cn(iconVariants({ variant, size }), className)}>
      <IconComponent color={color} {...svgProps} />
    </div>
  );
}
